import {useSelector} from "react-redux";
import {
    SW_FLIGHT_TYPES,
    SW_PASSENGER_TYPES,
} from "../../../../../store/types";
import {
    AIRPORTS_AZORES,
    AIRPORTS_WITH_RAIL_FLY,
} from "../../../../../store/reducers/search-widget";
import moment from "moment/moment";

const DATE_RANGES = [
    {
        start: "2026-03-29",
        end: "2026-05-31",
        daysOfWeek: [2, 6],
        origins: AIRPORTS_AZORES
    },
    {
        start: "2026-03-29",
        end: "2026-05-31",
        daysOfWeek: [2, 6],
        origins: AIRPORTS_WITH_RAIL_FLY
    },
    {
        start: "2026-06-04",
        end: "2026-10-01",
        daysOfWeek: [0, 3, 5],
        origins: AIRPORTS_AZORES
    },
    {
        start: "2026-06-04",
        end: "2026-10-01",
        daysOfWeek: [0, 3, 5],
        origins: AIRPORTS_WITH_RAIL_FLY
    },
    {
        start: "2026-10-04",
        end: "2026-10-21",
        daysOfWeek: [2, 6],
        origins: AIRPORTS_AZORES
    },
    {
        start: "2026-10-04",
        end: "2026-10-21",
        daysOfWeek: [2, 6],
        origins: AIRPORTS_WITH_RAIL_FLY
    },
];

const isDateEligible = (date, origin) => {
    return DATE_RANGES.some((range) => {
        if (range?.daysOfWeek) {
            const dayOfWeek = date.day();
            const startDate = moment(range.start);
            const endDate = moment(range.end);
            return (
                date.isBetween(startDate, endDate, null, "[]") &&
                range.daysOfWeek.includes(dayOfWeek) &&
                range?.origins?.includes(origin?.code)
            );
        }
        if (range?.dates) {
            return (
                range.dates.includes(date.format("YYYY-MM-DD")) &&
                range.origins.includes(origin?.code)
            );
        }
        return false;
    });
};

const useIsRailFlyEligibleConnected = () => {
    const origin = useSelector((state) => state.sw.book.origin);
    const destination = useSelector((state) => state.sw.book.destination);
    const passengerType = useSelector((state) => state.sw.book.passengerType);
    const promoCode = useSelector((state) => state.sw.book.promoCode);
    const flightType = useSelector((state) => state.sw.book.flightType);
    const withMiles = useSelector((state) => state.sw.book.withMiles);
    const isRoundTrip = flightType === SW_FLIGHT_TYPES.RETURN;
    const isOneWay = flightType === SW_FLIGHT_TYPES.ONE_WAY;
    const departureStr = useSelector((state) => state.sw.book.departure);
    const arrivalStr = useSelector((state) => state.sw.book.arrival);
    const departure = departureStr && moment(departureStr);
    const arrival = arrivalStr && moment(arrivalStr);
    const isEligibleToRailFly =
        (AIRPORTS_WITH_RAIL_FLY.includes(origin?.code) &&
            AIRPORTS_AZORES.includes(destination?.code)) ||
        (AIRPORTS_WITH_RAIL_FLY.includes(destination?.code) &&
            AIRPORTS_AZORES.includes(origin?.code));

    const isStartDateEligible = !isOneWay
        ? arrival && isDateEligible(arrival, origin)
        : true;
    const isEndDateEligible = departure && isDateEligible(departure, origin);

    return Boolean(
        (isRoundTrip || isOneWay) &&
        passengerType === SW_PASSENGER_TYPES.ADULT &&
        !promoCode &&
        !withMiles &&
        origin &&
        destination &&
        isEligibleToRailFly &&
        isStartDateEligible &&
        isEndDateEligible
    );
};

export default useIsRailFlyEligibleConnected;
